import { queryDefinitionAt } from '../index.js';
import type { CodeNavOpContext } from './code-nav-op-context.js';
import type { CodeNavHttpBody } from './types.js';

export async function runDefinitionOp(ctx: CodeNavOpContext): Promise<CodeNavHttpBody> {
  const definition = await queryDefinitionAt(ctx.sessionParentPath, ctx.reqPath, ctx.line, ctx.column);
  return { indexReady: true, definition };
}
